import Faq from '../components/pages/Faq';

export default Faq;
